export const getCreateCustomerPayload = (response) => {
  const axiosResponse = response?.success === false
    ? response?.error?.response
    : response?.data;

  return axiosResponse?.data?.data || axiosResponse?.data || {};
};

export const getPaymentActionClientSecret = (payload) =>
  payload?.payment_intent_client_secret ||
  payload?.client_secret ||
  payload?.payment?.client_secret ||
  payload?.payment_intent?.client_secret ||
  payload?.subscription?.latest_invoice?.payment_intent?.client_secret ||
  "";

export const subscriptionPaymentSucceeded = (payload) => {
  const subscriptionStatus = payload?.subscription?.status;
  const paymentIntentStatus =
    payload?.payment?.payment_intent_status ||
    payload?.payment_intent?.status ||
    payload?.subscription?.latest_invoice?.payment_intent?.status;

  return (
    subscriptionStatus === "trialing" ||
    subscriptionStatus === "active" ||
    paymentIntentStatus === "succeeded"
  );
};

export const subscriptionRequiresPaymentAction = (payload) => {
  const paymentIntentStatus =
    payload?.payment?.payment_intent_status ||
    payload?.payment_intent?.status ||
    payload?.subscription?.latest_invoice?.payment_intent?.status;

  return (
    payload?.requires_action === true ||
    payload?.payment?.requires_action === true ||
    paymentIntentStatus === "requires_action"
  );
};

export const confirmSubscriptionPaymentAction = async (stripe, clientSecret) => {
  if (!stripe) {
    return { error: { message: "Stripe is not ready yet. Please try again." } };
  }

  return stripe.confirmCardPayment(clientSecret);
};
